"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplificationUtils__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldA",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newA",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialTime",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "futureTime",
                type: "uint256",
            },
        ],
        name: "RampA",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "currentA",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "time",
                type: "uint256",
            },
        ],
        name: "StopRampA",
        type: "event",
    },
];
const _bytecode = "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220061b16fa817f4b0ca2b5a6583c9fa676f05525b52a19811ea25e293073a52e6e64736f6c63430008110033";
const isSuperArgs = (xs) => xs.length > 1;
class AmplificationUtils__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AmplificationUtils__factory = AmplificationUtils__factory;
AmplificationUtils__factory.bytecode = _bytecode;
AmplificationUtils__factory.abi = _abi;
//# sourceMappingURL=AmplificationUtils__factory.js.map